import "../css/article.scss"
import { BackButton } from "../UI/Buttons";
import ImageGallery from 'react-image-gallery';
import { useEffect, useMemo, useState } from "react";
import { sanityClient } from "../sanity/client";
import { eventGalleryQuery } from "../sanity/queries";
import { LoadingSpinner } from "../UI/LoadingSpinner";
import { Reveal } from "../UI/Reveal";

export const Events = () => {
    const [gallery, setGallery] = useState(null);
    const [loading, setLoading] = useState(true);
    const fallbackImages = useMemo(() => ([
        {
            original: require('../imgs/event1.jpeg'),
            thumbnail: require('../imgs/event1.jpeg'),
        },
        {
            original: require('../imgs/event2.jpeg'),
            thumbnail: require('../imgs/event2.jpeg'),
        },
    ]), []);

    useEffect(() => {
        let cancelled = false;
        sanityClient.fetch(eventGalleryQuery)
            .then((res) => {
                if (!cancelled) {
                    setGallery(res || null);
                    setLoading(false);
                }
            })
            .catch(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; }
    }, []);

    const images = useMemo(() => {
        if (!gallery?.images?.length) return fallbackImages;
        return gallery.images
            .filter(i => i?.asset)
            .map(i => ({
                original: i.url,
                thumbnail: i.url,
                description: i.caption || '',
                originalAlt: i.alt || '',
                thumbnailAlt: (i.alt || ''),
            }));
    }, [gallery, fallbackImages]);

    return (
        <>
            <BackButton path={-1} />


            <div className="article-container-new">
                <div className="article center">

                    <Reveal>
                        <h2>
                            Events
                        </h2>
                    </Reveal>


                    <div className="events-gallery-container">
                        {loading ? (
                            <LoadingSpinner label="Lädt…" size="lg" />
                        ) : (
                            <ImageGallery
                                items={images}
                                showPlayButton={false}
                                 showFullscreenButton={false}

                            />
                        )}
                    </div>

                </div></div>
        </>)
}
